'use client';
import MuiBox from '@new-components/atoms/MuiBox';
import {MediaQuery} from '@constants/theme';
import MuiSkeleton from '@new-components/atoms/MuiSkeleton';
import {Desktop} from '@components/Desktop';
import {Mobile} from '@components/Mobile';
import {
  CustomDesktopVideoPlayer,
  CustomMobVideoPlayer,
  Media,
} from './CustomVideoPlayer';
import MuiLink from '@new-components/atoms/MuiLink';
import { useState } from 'react';

export interface NewLaunchCardProps {
  desktop: Media;
  mobile: Media;
  exploreButtonLabel: string;
  exploreLink: string;
}

export const NewLaunchCardSkelton = () => {
  return (
    <MuiSkeleton
      width={'100%'}
      variant='rounded'
      animation='wave'
      height={560}
    />
  );
};

const NewLaunchCard: React.FC<NewLaunchCardProps> = (props) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <MuiBox
      data-testid={'latest-launch-card'}
      id='new-launch-card'
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        position: 'relative',
        minHeight: '80dvh',
        [MediaQuery.desktop]: {
          minHeight: '600px',
          height: '100%',
        },
        [MediaQuery.mobile]: {
          marginX: '16px',
        },
      }}>
      <Desktop>
        <CustomDesktopVideoPlayer media={props.desktop}  onFullscreenToggle={setIsFullscreen}/>
      </Desktop>
      <Mobile>
        <CustomMobVideoPlayer media={props.mobile} />
      </Mobile>
      {!isFullscreen  && <MuiLink
        href={props.exploreLink}
        target='_blank'
        underline='none'
        sx={{
          position: 'absolute',
          bottom: 16,
          left: 16,
          borderRadius: '500px',
          px: 10,
          minHeight: '40px',
          fontSize: '15px',
          fontWeight: 400,
          lineHeight: '18.75px',
          letterSpacing: '-0.4000000059604645px',
          border: `1px solid #fff`,
          color: '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          [MediaQuery.mobile]: {
            px: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%',
          },
        }}>
        {props.exploreButtonLabel}
      </MuiLink>}
    </MuiBox>
  );
};

export default NewLaunchCard;
